import { useEffect, useMemo } from 'react';
import styles from './salesAcumulated.module.scss';
import { SalesAcumulatedDashboardProps } from '../../../../interfaces/components'
import Chart from "react-apexcharts";
import { useToast } from '../../../../helpers/hooks';
import { addPointsInText, numberFormatter } from '../../../../helpers/app';
import { Skeleton } from '@mui/material';

const SalesAcumulated = ({
    user,
    branch,
    getSalesPeriod,
    cleanSalesAcumulated,
    salesAcumulated,
    className
}: SalesAcumulatedDashboardProps) => {
    const toast = useToast();
    const labels = ["ventas", "publicaciones"]

    const dataNormalized: any = useMemo(() => {
        let data = [0, 100];
        if(salesAcumulated?.data?.publications && (!(salesAcumulated?.data?.publications?.total_quantity === 0 || salesAcumulated?.data?.sales?.total_quantity === 0))){
            data = [salesAcumulated?.data?.sales?.total_quantity, salesAcumulated?.data?.publications?.total_quantity];
        }
        return data;
    }, [salesAcumulated?.data]);

    useEffect(() => {
        if(salesAcumulated?.fetching === "failure"){
            if(salesAcumulated?.error){
                toast("Ha ocurrido un error al mostrar las ventas de los ultimos 30 dias");
            }
            cleanSalesAcumulated();
        }
        if(salesAcumulated?.fetching === "success"){
            cleanSalesAcumulated();
        }
    }, [salesAcumulated?.fetching]);

    
    useEffect(() => {
        if(user?.branch || branch !== ""){
            const dateStart = new Date();
            const dateEnd = new Date();
            dateStart.setDate(dateStart.getDate() - 30);
            getSalesPeriod(dateStart, dateEnd, "acumulated");
        }
    }, [branch]);

    return(
        <div className={`${styles.salesAcumulated} ${className}`}>
                <div className={styles.info}>
                    <p className={styles.title}>Ventas últimos 30 días</p>
                    {
                        salesAcumulated?.fetching === "loading" 
                        ? <Skeleton animation="wave" variant="text" className={`${styles.value} ${styles.skeleton}`} />
                        : <p className={styles.value}>${numberFormatter(salesAcumulated?.data?.sales?.total_price, 1)}</p>
                    }
                    <p className={styles.subtitle}>
                        {   
                            salesAcumulated?.fetching === "loading" 
                            ?   "Cargando ventas..."
                            :   `Se ${salesAcumulated?.data?.sales?.total_quantity === 1 ? 'vendió' : 'vendieron'} ${addPointsInText(salesAcumulated?.data?.sales?.total_quantity)} vehículo${(salesAcumulated?.data?.sales?.total_quantity === 1) ? '' : 's'}`
                        }
                    </p>
                </div>
                <div className={styles.data}>
                    <Chart 
                        type="donut" 
                        series={dataNormalized} 
                        width="90px"
                        height="90px"
                        options={{
                            chart: {
                                parentHeightOffset: 0,
                                sparkline: {
                                    enabled: true,
                                }
                            },
                            labels: labels,
                            plotOptions: {
                                pie: {
                                    expandOnClick: false,
                                    donut: {
                                        size: '50px'
                                    }
                                }
                            },
                            dataLabels: {
                                enabled: false
                            },
                            legend: {
                                show: false
                            },
                            tooltip: {
                                enabled: false
                            },
                            fill: {
                                colors: ['#4874D0', '#E4E8EF'],
                                opacity: 1
                            },
                            stroke: {
                                width: 0
                            },
                            states: {
                                hover: {
                                    filter: {
                                        type: 'none'
                                    }
                                },
                                active: {
                                    filter: {
                                        type: 'none',
                                    }
                                },
                            }
                        }}
                    />
                </div>
        </div>
    )
}

export default SalesAcumulated;